import { render } from "./ThemeTypography.vue?vue&type=template&id=58bfaa48&scoped=true"
import script from "./ThemeTypography.vue?vue&type=script&lang=js"
export * from "./ThemeTypography.vue?vue&type=script&lang=js"

import "./ThemeTypography.vue?vue&type=style&index=0&id=58bfaa48&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58bfaa48"]])

export default __exports__